import { gql } from "@apollo/client";
import { client } from "../App";
import { notification } from "antd";

const ADD_OR_REPLACE_MIGRATION_FILE_MUTATION = gql`
  mutation addOrReplaceMigrationFile(
    $migrationId: ID!
    $filename: String!
    $url: String!
  ) {
    addOrReplaceMigrationFile(
      migrationId: $migrationId
      filename: $filename
      url: $url
    ) {
      id
    }
  }
`;

const DELETE_MIGRATION_FILE_MUTATION = gql`
  mutation deleteMigrationFile($id: ID!) {
    deleteMigrationFile(id: $id) {
      id
    }
  }
`;

export async function addFileToMigration(
  migrationId: string | number,
  filename: string,
  url: string,
  refetchQueries?: any[]
): Promise<string> {
  let migrationFileId: string;
  await client
    .mutate({
      mutation: ADD_OR_REPLACE_MIGRATION_FILE_MUTATION,
      variables: {
        migrationId: migrationId,
        filename: filename,
        url: url,
      },
      refetchQueries: refetchQueries,
      awaitRefetchQueries: true,
    })
    .then((response) => {
      migrationFileId = response.data.addOrReplaceMigrationFile.id;
      notification["success"]({
        message: `Successfully added ${filename} to Migration`,
      });
    })
    .catch((err) => {
      notification["error"]({
        message: `Failed to add ${filename} to Migration`,
        description: err.message,
      });
    });
  return migrationFileId;
}

export async function removeFileFromMigration(
  migrationFileId: string | number,
  filename: string,
  refetchQueries?: any[]
): Promise<boolean> {
  let success: boolean;
  await client
    .mutate({
      mutation: DELETE_MIGRATION_FILE_MUTATION,
      variables: { id: migrationFileId },
      refetchQueries: refetchQueries,
      awaitRefetchQueries: true,
    })
    .then(() => {
      notification["success"]({
        message: `Successfully deleted ${filename} from Migration`,
      });
      success = true;
    })
    .catch((err) => {
      notification["error"]({
        message: `Failed to delete ${filename} from Migration`,
        description: err.message,
      });
      success = false;
    });
  return success;
}
